import { render } from "./DescribeSegmentModal.vue?vue&type=template&id=6f122350"
import script from "./DescribeSegmentModal.vue?vue&type=script&lang=js"
export * from "./DescribeSegmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/DescribeSegmentModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f122350"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f122350', __exports__)) {
    api.reload('6f122350', __exports__)
  }
  
  module.hot.accept("./DescribeSegmentModal.vue?vue&type=template&id=6f122350", () => {
    api.rerender('6f122350', render)
  })

}


export default __exports__